<template>  
	<div class="row">
		<div class="documentation">
			<div class="documentation-container">
				
				<div id="response_errors" class="response_errors_container" style="display:none"></div>
				
				<div v-if="element == 'software'">
					
					<nav aria-label="breadcrumb" class="d-none d-xl-block">
						<ol class="breadcrumb">
							<li class="breadcrumb-item"><a href="/docs">Документы</a></li>
							<li class="breadcrumb-item"><a href="/docs-edit">Список документов</a></li>
							<li v-if="type == 'create'" class="breadcrumb-item active" aria-current="page">Добавить новую программу</li>
							<li v-if="type == 'update'" class="breadcrumb-item active" aria-current="page">Редактировать программу</li>
						</ol>
					</nav>
					<div class="title-block">
						<div class="title-block__left">
							<div v-if="type == 'create'" class="title-block__title">
								Добавить новую программу
							</div>
							<div v-if="type == 'update'" class="title-block__title">
								Редактировать программу
							</div>
						</div>
					</div>
					
					<input type="hidden" id="softwareIdInput" v-bind:value="elementdetail.id">
					
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Название программы *</div>
							<input type="text" class="form-control" id="softwareNameInput" placeholder="введите название" v-bind:value="elementdetail.name">
						</div>
					</div>
										
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Описание программы</div>
							<textarea name="" id="softwareDescriptionInput" cols="30" rows="3" class="form-control" placeholder="введите описание">{{ elementdetail.description }}</textarea>
						</div>
					</div>
					
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Выберите клиента *</div>
							<select v-if="elementdetail.clients" id="softwareClientInput" class="form-select" size="5" multiple>
								<option v-for="cl in clientlist" v-bind:value="cl.id" :selected="elementdetail.clients.includes(cl.id)? true : false">{{ cl.name }}</option>
							</select>
							<select v-else id="softwareClientInput" class="form-select" size="5" multiple>
								<option v-for="cl in clientlist" v-bind:value="cl.id">{{ cl.name }}</option>
							</select>
						</div>
					</div>
					
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Url программы *</div>
							<input type="text" class="form-control" id="softwareUrlInput" placeholder="введите url" v-bind:value="elementdetail.url">
						</div>
					</div>
					
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Порядок сортировки</div>
							<input type="text" class="form-control" id="softwareSortInput" placeholder="введите порядок сортировки" v-bind:value="elementdetail.sort">
						</div>
					</div>
					
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-check">
								<input class="form-check-input" type="checkbox" value="" id="softwareVisibleInput" :checked="elementdetail.visible == 0 ? false : true">
								<label class="form-check-label" for="softwareVisibleInput"> Опубликован</label>
							</div>
						</div>
					</div>
					
					<div class="d-flex flex-column flex-lg-row justify-content-between">
						<button class="btn mb-2 mb-lg-0 me-lg-auto" @click.prevent="saveSoftware">
							<span>Сохранить</span>
						</button>
						<button class="btn btn-lg btn-outline-dark" @click.prevent="cancel">
							<span>Отменить</span>
						</button>
					</div>
					
				</div>
				
				<div v-if="element == 'version'">
					
					<nav aria-label="breadcrumb" class="d-none d-xl-block">
						<ol class="breadcrumb">
							<li class="breadcrumb-item"><a href="/docs">Документы</a></li>
							<li class="breadcrumb-item"><a href="/docs-edit">Список документов</a></li>
							<li v-if="type == 'create'" class="breadcrumb-item active" aria-current="page">Добавить новую версию</li>
							<li v-if="type == 'update'" class="breadcrumb-item active" aria-current="page">Редактировать версию</li>
						</ol>
					</nav>
					<div class="title-block">
						<div class="title-block__left">
							<div v-if="type == 'create'" class="title-block__title">
								Добавить новую версию
							</div>
							<div v-if="type == 'update'" class="title-block__title">
								Редактировать версию
							</div>
						</div>
					</div>
					
					<input type="hidden" id="softwareIdInput" v-bind:value="elementdetail.id">
					
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Номер версии *</div>
							<input type="text" class="form-control" id="versionNumberInput" placeholder="введите номер" v-model="versionNumber">
						</div>
					</div>
					
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Название версии *</div>
							<input type="text" class="form-control" id="versionNameInput" placeholder="введите название" :value="elementdetail.name">
						</div>
					</div>
										
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Описание версии</div>
							<textarea name="" id="versionDescriptionInput" cols="30" rows="3" class="form-control" placeholder="введите описание">{{ elementdetail.description }}</textarea>
						</div>
					</div>
					
					<input type="hidden" id="versionClientInput">
					<div class="row mb-4">
						<div class="col-12">	
							<div class="form-label">Выберите клиента *</div>
							<v-select class="searchable" v-model="clientOption" 
								:options="clientOptions"
								@option:selected="onVersionClientChange($event)"
								:deselectFromDropdown="true"
								:clearable="false">
								<template #no-options="{ search, searching, loading }">
									<div class="text-not-found">Не найдено</div>
								</template>
							</v-select>
						</div>	
					</div>
					
					<input type="hidden" id="versionSoftwareInput">
					<div class="row mb-4">
						<div class="col-12">	
							<div class="form-label">Выберите программу *</div>
							<v-select class="searchable" v-model="softwareOption"
								:options="softwareOptions"
								@option:selected="onVersionSoftwareChange($event)"
								:deselectFromDropdown="false"
								:clearable="false">
								<template #no-options="{ search, searching, loading }">
									<div class="text-not-found">Не найдено</div>
								</template>
							</v-select>
						</div>	
					</div>
					
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Дата релиза</div>
							<input type="date" class="form-control" id="versionReleaseDateInput" placeholder="Placeholder">
						</div>
					</div>
					
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Дата окончания техподдержка</div>
							<input type="date" class="form-control" id="versionSupportEndDateInput" placeholder="Placeholder">
						</div>
					</div>
					
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Дата начала показа</div>
							<input type="date" class="form-control" id="versionStartDateInput" placeholder="Placeholder">
						</div>
					</div>					
					
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-check">
								<input class="form-check-input" type="checkbox" value="" id="versionVisibleInput" :checked="elementdetail.visible == 0 ? false : true">
								<label class="form-check-label" for="versionVisibleInput"> Опубликован</label>
							</div>
						</div>
					</div>
					
					<div class="d-flex flex-column flex-lg-row justify-content-between">
						<button class="btn mb-2 mb-lg-0 me-lg-auto" @click.prevent="saveVersion">
							<span>Сохранить</span>
						</button>
						<button class="btn btn-light" @click.prevent="cancel">
							<span>Отменить</span>
						</button>
					</div>
					
				</div>
				

			</div>
		</div>	
    </div>

	<Alert />
</template>

<script>
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import ImageUploader from 'quill-image-uploader';
import Alert from '../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: "CreateDocumentationComponent",
	components: {
        QuillEditor,
		Alert,
    },
	props: [
        'type',
        'element',
        'elementdetail',
		'clientlist',
		'softwarelist',
    ],
    setup: () => {
        const modules = {
            name: 'imageUploader',
            module: ImageUploader,
            options: {
                upload: file => {
                    return new Promise((resolve, reject) => {
                        const formData = new FormData();
                        formData.append("image", file);
                        axios.post('/technical/letter-constructor/upload', formData)
                            .then(res => {
                                if (res.data.status == 'ok') {
                                    resolve(res.data.url);
                                } else {
									this.addAlert({ type: 'error', title: 'Ошибка', text: res.data.message });
                                    reject("Upload failed");
                                }
                            })
                            .catch(err => {
                                reject("Upload failed");
                            });
                    });
                }
            }
        }
        return modules;
    },
    data: () => {
        return {
            program: 'Выберите программу',
            suggestionsOpen: false,
            parentDoc: '',
            parentDocIcon: '',
            content: '',
            previewOpen: false,
            clientOptions: [],
            softwareOptions: [],
            clientOption: {label: ''},
            softwareOption: {label: ''},
            versionNumber: '',
        };
    },
	created() {
		if(this.clientlist.length > 0) {
			var list = [];
			this.clientlist.forEach(obj => {
				list.push({
					value: obj.id,
					label: obj.name,
				});
			});
			this.clientOptions = list;
		};
		
		if(this.softwarelist.length > 0) {
			var list = [];
			this.softwarelist.forEach(obj => {
				list.push({
					value: obj.id,
					label: obj.name
				});
			});
			this.softwareOptions = list;
		}
  },
    methods: {
		...mapMutations('alerts', ['addAlert']),
		itemGet: async function () {
            this.versionNumber = this.elementdetail.number;
        },
		
		docSuggesttionsHandler: function (e) {
            const target = e.target;
            if (target.classList.contains('has-list')) {
                target.classList.toggle('open');
            } else {
                const link = target.closest('a') || false;
                if (link) {
                    const text = link.textContent;
                    const icon = link.classList[0] || false;
                    if (text) {
                        this.parentDoc = text;
                    }
                    if (icon) {
                        this.parentDocIcon = `icon ${icon}`;
                    } else {
                        this.parentDocIcon = '';
                    }
                    this.closeSuggestions();
                }

            }
        },
        resetChoice: function (e) {
            this.parentDocIcon = '';
            e.target.parentElement.setAttribute('class', 'search-control doc-search-control');
            this.openSuggestions();
        },
        openSuggestions: function () {
            this.suggestionsOpen = true;
        },
        closeSuggestions: function () {
            this.suggestionsOpen = false;
        },
        preview: function () {
            //Не безопасно!!!
            this.previewOpen = !this.previewOpen;
            if (this.previewOpen) {
                this.$refs.documentPreviewContent.innerHTML = this.$refs.documentEditor.getHTML();
            } else {
                this.$refs.documentPreviewContent.innerHTML = '';
            }
        },
        save: function () {
            if (this.previewOpen) {
                this.$refs.documentPreviewContent.innerHTML = this.$refs.documentEditor.getHTML();
            }
            //Далее - записать данные в базу
        },
		cancel: function () {
			document.location = '/docs-edit';
		},
		saveSoftware: function () {
			const clients = Array.prototype.slice.call(document.querySelectorAll('#softwareClientInput option:checked'),0).map(function(v,i,a) { 
				return v.value; 
			});
			var softwareData = {
				type: this.type,
				name: document.getElementById('softwareNameInput').value,
				description: document.getElementById('softwareDescriptionInput').value,
				client: clients,
				url: document.getElementById('softwareUrlInput').value,
				sort: document.getElementById('softwareSortInput').value,
				visible: document.getElementById('softwareVisibleInput').checked ? 1 : 0,
			};
			if(this.type == 'update') {
				softwareData.id = document.getElementById('softwareIdInput').value;
			}
			axios.post('/docs-edit/software', softwareData)
				.then(res => {
					if(res.data.status == 'error') {
						var error_list = '<h5>При добавлении программы произошли следующие ошибки:</h5><ul>';
						res.data.errors.forEach(error => {
							error_list += '<li>' + error + '</li>'
						});
						error_list += '</ul>';
						document.getElementById('response_errors').innerHTML = error_list;
						document.getElementById('response_errors').style.display = 'block';
						document.getElementById('response_errors').scrollIntoView({behavior: "smooth"});
					} else if(res.data.status == 'ok') {
						document.location = '/docs-edit';
					}
				});
		},
		saveVersion: function () {
			var versionData = {
				type: this.type,
				software: document.getElementById('versionSoftwareInput').value,
				number: document.getElementById('versionNumberInput').value,
				name: document.getElementById('versionNameInput').value,
				description: document.getElementById('versionDescriptionInput').value,
				release_date: document.getElementById('versionReleaseDateInput').value,
				support_end_date: document.getElementById('versionSupportEndDateInput').value,
				start_date: document.getElementById('versionStartDateInput').value,
				visible: document.getElementById('versionVisibleInput').checked ? 1 : 0,
			};
			if(this.type == 'update') {
				versionData.id = document.getElementById('versionIdInput').value;
			}
			axios.post('/docs-edit/version', versionData)
				.then(res => {
					if(res.data.status == 'error') {
						var error_list = '<h5>При добавлении версии произошли следующие ошибки:</h5><ul>';
						res.data.errors.forEach(error => {
							error_list += '<li>' + error + '</li>'
						});
						error_list += '</ul>';
						document.getElementById('response_errors').innerHTML = error_list;
						document.getElementById('response_errors').style.display = 'block';
						document.getElementById('response_errors').scrollIntoView({behavior: "smooth"});
					} else if(res.data.status == 'ok') {
						document.location = '/docs-edit';
					}
				});
		},
		closeModalError: function () {
			this.$refs.modalerror.show = false;
		},
		onVersionClientChange(events) {
			
			console.log(events);
			
			/*document.getElementById('versionClientInput').value = events.value;
			this.buildSoftwareOption();
			document.getElementById('versionSoftwareInput').value = '';*/
		},
		onVersionSoftwareChange(events) {
		
			console.log(events);
			/*document.getElementById('versionSoftwareInput').value = events.value;*/
		},
		buildSoftwareOption: function () {
			var client = document.getElementById('versionClientInput').value;
			if(this.softwarelist.length > 0) {
				var list = [];
				this.softwarelist.forEach(obj => {
					if(obj.client == client) {	
						list.push({
							value: obj.id,
							label: obj.name
						});
					}	
				});
				this.softwareOptions = list;
				this.softwareOption = {label: ''};
			}
		},
    },
    mounted() {
        document.addEventListener("keydown", (e) => {
            if (e.key == 'Escape') {
                this.closeSuggestions();
            }
        });
        document.addEventListener("click", (e) => {
            if (!e.target.closest('.doc-search-control')) {
                this.closeSuggestions();
            }
        });
		this.itemGet();
    },
};
</script>
